import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { submitContact, getLPSettings } from "../services/api";
import { isValidGoogleMapsEmbedUrl } from "../utils/googleMapsEmbed";
import "./Contact.css";

const DEFAULT_CONTACT_INFO = {
  alamat:
    "Jl. Laksda Adisucipto, Papringan, Caturtunggal, Kec. Depok, Kabupaten Sleman, Daerah Istimewa Yogyakarta 55281",
  telepon: "(0274) 512474",
  email: "halalcenter@uin-suka.ac.id",
  jam_operasional: "Senin - Jumat: 08:00 - 17:00 WIB",
};

const Contact = () => {
  const [formData, setFormData] = useState({
    nama: "",
    telpon: "",
    email: "",
    pesan: "",
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const [contactInfo, setContactInfo] = useState(DEFAULT_CONTACT_INFO);

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const { data } = await getLPSettings();
        if (!data) return;

        const alamat =
          [data.alamat, data.desa, data.kode_pos]
            .map((v) => (v || "").toString().trim())
            .filter(Boolean)
            .join(", ") || DEFAULT_CONTACT_INFO.alamat;

        setContactInfo({
          alamat,
          telepon: data.no_hp?.trim() || DEFAULT_CONTACT_INFO.telepon,
          email: data.email?.trim() || DEFAULT_CONTACT_INFO.email,
          jam_operasional:
            data.jam_operasional?.trim() ||
            DEFAULT_CONTACT_INFO.jam_operasional,
          google_maps_embed: data.google_maps_embed?.trim() || "",
        });
      } catch (error) {
        // Gunakan nilai default jika gagal memuat pengaturan
      }
    };

    fetchContactInfo();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert({ show: false, type: "", message: "" });

    try {
      const response = await submitContact(formData);
      if (response.data.success) {
        setAlert({
          show: true,
          type: "success",
          message: "Pesan Anda telah terkirim. Terima kasih!",
        });
        setFormData({ nama: "", telpon: "", email: "", pesan: "" });
      }
    } catch (error) {
      setAlert({
        show: true,
        type: "danger",
        message: "Terjadi kesalahan. Silakan coba lagi.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <Container>
          <h1>Hubungi Kami</h1>
        </Container>
      </div>

      <Container className="content-section">
        <Row>
          <Col md={6} className="mb-4">
            <div className="contact-info-card">
              <h3>Informasi Kontak</h3>
              <div className="contact-info-item">
                <h5>Alamat</h5>
                <p>{contactInfo.alamat}</p>
              </div>

              <div className="contact-info-item">
                <h5>Telepon</h5>
                <p>{contactInfo.telepon}</p>
              </div>

              <div className="contact-info-item">
                <h5>Email</h5>
                <p>{contactInfo.email}</p>
              </div>

              <div className="contact-info-item">
                <h5>Jam Operasional</h5>
                <p>{contactInfo.jam_operasional}</p>
              </div>
            </div>
          </Col>

          <Col md={6}>
            <div className="contact-form-card">
              <h3>Kirim Pesan</h3>

              {alert.show && (
                <Alert
                  variant={alert.type}
                  onClose={() => setAlert({ ...alert, show: false })}
                  dismissible
                >
                  {alert.message}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Nama <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="nama"
                    value={formData.nama}
                    onChange={handleChange}
                    placeholder="Masukkan nama Anda"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Telepon <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    name="telpon"
                    value={formData.telpon}
                    onChange={handleChange}
                    placeholder="Masukkan nomor telepon"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Email <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Masukkan alamat email"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Pesan <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="pesan"
                    value={formData.pesan}
                    onChange={handleChange}
                    placeholder="Tulis pesan Anda di sini..."
                    required
                  />
                </Form.Group>

                <Button
                  type="submit"
                  disabled={loading}
                  className="btn-contact-submit"
                >
                  {loading ? "Mengirim..." : "Kirim Pesan"}
                </Button>
              </Form>
            </div>
          </Col>
        </Row>

        {isValidGoogleMapsEmbedUrl(contactInfo.google_maps_embed) && (
          <Row className="mt-2">
            <Col xs={12}>
              <div className="contact-map-card">
                <h3>Lokasi Kami</h3>
                <div className="contact-map-embed">
                  <iframe
                    title="Lokasi lembaga di Google Maps"
                    src={contactInfo.google_maps_embed}
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Contact;
